import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    chatRoomData: {
      chatRoomId: null,
      isEnd: false,
      headerStyle: false,
      customOptionInfos: [],
      showInput: false,
      messagesData: [],
      gnbs: []
    },
    historyData: {
      roomList: [],
      currentPage: 1,
      totalPages: 1,
      isProgress: false
    },
    brandId: 0
  };
};

export default new Vuex.Store({
  state: getDefaultState(),
  getters: {
    chatRoomData: (state) => {
      return state.chatRoomData;
    },
    historyData: (state) => {
      // 이전 상담 내역 - 현재 미사용
      return state.historyData;
    },
    brandId: (state) => {
      return state.brandId;
    }
  },
  actions: {},
  mutations: {
    clearChatRoomData(state) {
      state.chatRoomData = {
        chatRoomId: null,
        isEnd: false,
        headerStyle: false,
        customOptionInfos: [],
        showInput: false,
        messagesData: [],
        gnbs: []
      };
    },
    setChatRoomData(state, chatRoomData) {
      state.chatRoomData = chatRoomData;
    },
    setHeaderStyle(state, headerStyle) {
      state.chatRoomData.headerStyle = headerStyle;
    },
    setCustomOptionInfos(state, customOptionInfos) {
      state.chatRoomData.customOptionInfos = customOptionInfos;
    },
    setMessagesData(state, messagesData) {
      state.chatRoomData.messagesData = messagesData;
    },
    setChatRoomId(state, chatRoomId) {
      state.chatRoomData.chatRoomId = chatRoomId;
    },
    setShowInput(state, showInput) {
      state.chatRoomData.showInput = showInput;
    },
    setGnbs(state, gnbs) {
      state.chatRoomData.gnbs = gnbs;
    },
    setIsEnd(state, isEnd) {
      state.chatRoomData.isEnd = isEnd;
    },
    clearHistoryData(state) {
      state.historyData = {
        roomList: [],
        currentPage: 1,
        totalPages: 1,
        isProgress: false
      };
    },
    setHistoryData(state, historyData) {
      state.historyData = historyData;
    },
    setBrandId(state, brandId) {
      state.brandId = brandId;
    }
  }
});
